import React from 'react';
import { CTAButton } from './CTAButton';
import { CarouselControls } from './CarouselControls';
import { TOMOS } from './salesData';
import { useCarousel } from '../hooks/useCarousel';
export function TomosSection() {
  const {
    trackRef,
    index,
    goTo
  } = useCarousel(TOMOS.length);
  return <section id="tomos" className="overflow-hidden bg-charcoal pb-16 pt-14 text-white sm:py-20" data-id="element-244" data-mp="1u2dhgiyd443j">
      <div className="mx-auto max-w-5xl px-5" data-id="element-245" data-mp="xcnv0104ysld">
        <div className="text-center" data-id="element-246" data-mp="xdywfu63zo9b">
          <p className="font-display text-[0.66rem] font-bold uppercase tracking-editorial text-gold" data-id="element-247" data-mp="11dzmyd6hfpwq">
            La colección
          </p>
          <h2 className="mx-auto mt-3 max-w-[22ch] font-display text-[1.7rem] font-extrabold leading-[1.1] tracking-tight sm:max-w-[30ch] sm:text-[2.5rem]" data-id="element-248" data-mp="16cauuid7vqcb">
            No es un recetario suelto. Son{' '}
            <span className="text-gold" data-id="element-249" data-mp="2hrfzhrwwryyk">6 tomos que cubren todo el día.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-[46ch] font-sans text-[0.93rem] leading-relaxed text-white/75 sm:max-w-2xl sm:text-[1rem]" data-id="element-250" data-mp="2mq10htjzimo2">
            Cada tomo resuelve un momento distinto de tu alimentación, para que nunca te quedes sin
            ideas. Todas las recetas son Keto y Sin TACC, con ingredientes habituales en Argentina.
          </p>
        </div>

        <div ref={trackRef} role="region" aria-roledescription="carrusel" aria-label="Los 6 tomos de la colección" className="no-scrollbar relative -mx-5 mt-9 flex snap-x snap-mandatory gap-3 overflow-x-auto overscroll-x-contain scroll-px-5 px-5 md:mx-0 md:grid md:grid-cols-3 md:overflow-visible md:px-0" data-id="element-251" data-mp="2copnvp95u7mp">
          {TOMOS.map(tomo => <article key={tomo.num} role="group" aria-roledescription="diapositiva" aria-label={`Tomo ${tomo.num} de ${TOMOS.length}: ${tomo.name}`} className="flex w-[80%] shrink-0 snap-start flex-col rounded-2xl bg-white/[0.07] p-3 ring-1 ring-white/10 sm:w-[46%] md:w-auto" data-id="element-252" data-mp="1ty7ztxz9w07o">
              <div className="flex h-[300px] items-center justify-center rounded-xl bg-white/[0.05] p-2" data-id="element-253" data-mp="1ae93vwj7sb3y">
                <img src={tomo.cover} alt={`Portada del Tomo ${tomo.num}: ${tomo.name}`} loading="lazy" decoding="async" width={1055} height={1491} className="h-full w-auto max-w-full object-contain drop-shadow-[0_14px_20px_rgba(0,0,0,0.35)]" data-id="element-254" data-mp="1f96db4keomhd" />
              </div>
              <div className="flex flex-1 flex-col px-1 pb-1 pt-3.5" data-id="element-255" data-mp="1y3l96lbf7z0z">
                <span className="inline-flex w-fit items-center rounded-md bg-gold px-2 py-0.5 font-display text-[0.62rem] font-extrabold uppercase tracking-[0.08em] text-charcoal" data-id="element-256" data-mp="1k9u9s5relviz">
                  Tomo {tomo.num}
                </span>
                <h3 className="mt-2 font-display text-[1.02rem] font-bold leading-tight tracking-tight text-white" data-id="element-257" data-mp="2gs8e93tlkoek">
                  {tomo.name}
                </h3>
                <p className="mt-1.5 font-sans text-[0.82rem] leading-snug text-white/70" data-id="element-258" data-mp="5bgcwvdowdif">
                  {tomo.desc}
                </p>
                <p className="mt-auto pt-3 font-display text-[0.58rem] font-bold uppercase tracking-editorial text-gold" data-id="element-259" data-mp="f2t2thfxgtlt">
                  Keto + Sin TACC
                </p>
              </div>
            </article>)}
        </div>

        <CarouselControls label="Tomo" index={index} count={TOMOS.length} onGo={goTo} tone="dark" className="mt-5 md:hidden" data-id="element-260" data-mp="3ikba9nrsfylp" />

        <div className="mt-9 flex justify-center" data-id="element-261" data-mp="3siqpothgdjfd">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-262" data-mp="3nj5qqj2a9b2n" />
        </div>
      </div>
    </section>;
}